import { Routes } from '@angular/router';
import { SubscriptionListComponent } from './subscription-list/component';
import { PurchaseHandlerComponent } from 'army-builder-shared';

export const SUBSCRIPTION_PAGE_ROUTES: Routes = [
    {
        path: '',
        component: SubscriptionListComponent,
        data: { hideSidebar: true }
    },
    {
        path: 'restore',
        component: PurchaseHandlerComponent,
        data: {
            hideSidebar: true,
            requiredRoles: ['app_subscriber', 'app_subscriber_annual']
        }
    }
];
